const _ = require('lodash');

const hasVideoElement = (elements) => {
  return Boolean(_.find(elements, {
    style: {
      newBackground: {
        type: 'video'
      }
    }
  }));
};

const getIndexedElementsById = (elements) => {
  return _.chain(elements)
    .map((element, i) => ({ element, i }) )
    .reduce((byId, indexedElement) => {
      byId[indexedElement.element.id] = indexedElement;
      return byId;
    }, {})
    .value();
};

const getContainersAndChildElements = (indexedElementsById) => {
  return _.chain(indexedElementsById)
    .values()
    .filter((indexedElement) => Boolean(indexedElement.element.containerId))
    .map((indexedElement) => {
      return {
        container: indexedElementsById[indexedElement.element.containerId],
        child: indexedElementsById[indexedElement.element.id]
      };
    })
    .value();
};

const findErrors = (containerAndChildElements) => {
  const ERROR_MESSAGE = [
    'PB-1859 Video background and its container',
    'element are in the wrong order.'
  ].join(' ');

  const errors = [];

  _.each(containerAndChildElements, (containerAndChildElement) => {
    if (containerAndChildElement.container.i > containerAndChildElement.child.i) {
      errors.push(ERROR_MESSAGE);
    }
  });

  return errors;
};

// Detects if there are elements whose container comes after them in the pom.
//   The issue relates to video backgrounds not working when the container for an
//   image comes after the image's element.
module.exports = (pom) => {
  const elements = pom.mainPage.elements;

  // Issue only affects video background elements
  if (hasVideoElement(elements) === false) { return []; }

  // returns elements coupled with their indexes
  // (ex: { element: {...}, i: indexOfTheElementInListOfElements })
  const indexedElementsById = getIndexedElementsById(elements);

  // returns pairings of indexedElement with their container (also indexedElement)
  // (ex: { container: {...}, child: {...} })
  const containerAndChildElements = getContainersAndChildElements(indexedElementsById);

  // Goes through each pairing of child indexedElement to container indexedElement and returns
  // error messages if an ordering issue is present
  const errors = findErrors(containerAndChildElements);

  return errors;
};



// WEBPACK FOOTER //
// ./src/data/pom-metrics/video-bg-order-issue.js